import { useMutation, useQuery, useQueryClient, queryOptions } from '@tanstack/react-query';
import { TenantPreferences, type UpdateTenantPreferencesRequest } from '@sourcito/schemas';
import { apiFetch } from './api';

export const tenantPreferencesQuery = queryOptions({
  queryKey: ['tenant', 'preferences'] as const,
  queryFn: () =>
    apiFetch<TenantPreferences>('/api/me/preferences', {
      responseSchema: TenantPreferences,
    }),
  staleTime: 60_000,
});

export function useTenantPreferences() {
  return useQuery(tenantPreferencesQuery);
}

export function useUpdateTenantPreferences() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: UpdateTenantPreferencesRequest) =>
      apiFetch<TenantPreferences>('/api/me/preferences', {
        method: 'PUT',
        body: JSON.stringify(input),
        responseSchema: TenantPreferences,
      }),
    onSuccess: (data) => {
      qc.setQueryData(['tenant', 'preferences'], data);
    },
  });
}
